import gql from 'graphql-tag';
import * as _ from 'lodash';
import { DollarApollo } from 'vue-apollo/types/vue-apollo';

import groupFields from '@/queries/fields/groupFields';
import lightFields from '@/queries/fields/lightFields';
import { LightModeFields } from './fields/lightModeFields';
import { WizclickSettingsInput } from '@/queries/wizclickSettings';
import Group from '@/interfaces/Group';

export interface UpdateGroupGraphQLInput {
  name?: string;
  roomId?: string;
  fadeIn?: number;
  fadeOut?: number;
  startupMode?: string;
  defaultDimming?: number;
  wizclick1?: WizclickSettingsInput;
  wizclick2?: WizclickSettingsInput;
}

export const createGroupMutation = gql`
  mutation ($floorId: String!, $roomId: String!, $data: CreateGroupInput!) {
    createGroup(floorId: $floorId, roomId: $roomId, data: $data) {
      ...groupFields
    }
  }
  ${groupFields}
  ${lightFields}
`;

const pulseGroupMutation = gql`
  mutation($id: String!) {
    pulseGroup(id: $id)
  }
`;

export const lightIdsInGroupQuery = gql`
  query group($id: String!) {
    group(id: $id) {
      id
      lights {
        id
      }
    }
  }
`;

export async function pulseGroup(apollo: DollarApollo<any>, groupId: string) {
  try {
    await apollo.mutate({
      mutation: pulseGroupMutation,
      variables: {
        id: groupId,
      },
    });
  } catch (e) {
    throw e;
  }
}

export namespace GroupWithDimmingForLights {

  export const query = gql`
    query group($id: String!) {
      group(id: $id) {
        id
        lights {
          id
          currentState {
            dimming
          }
        }
      }
    }
  `;

  export interface Definition {
    group: {
      id: string;
      lights: {
        id: string;
        currentState: {
          dimming: number;
        };
      }[];
    };
  }

}

export namespace GroupWithLightModeForLights {

  export const query = gql`
    query group($id: String!) {
      group(id: $id) {
        id
        lights {
          id
          currentState {
            mode {
              ...lightModeFields
            }
          }
        }
      }
    }
    ${LightModeFields.fragment}
  `;

  export interface Definition {
    group: {
      id: string;
      lights: {
        id: string;
        currentState: {
          mode: LightModeFields.Definition;
        };
      }[];
    };
  }

}

export namespace GroupWithFanStateForLights {

  export const query = gql`
    query group($id: String!) {
      group(id: $id) {
        id
        lights {
          id
          currentState {
            fanState
          }
        }
      }
    }
  `;

  export interface Definition {
    group: {
      id: string;
      lights: {
        id: string;
        currentState: {
          fanState: boolean;
        };
      }[];
    };
  }
}

export namespace GroupWithAllFields {
  export const query = gql`
    query group($id: String!) {
      group(id: $id) {
        ...groupFields
      }
    }
    ${groupFields}
    ${lightFields}
  `;

  export interface Definition {
    group: Group;
  }
}
